<template>
  <div class="login-card forget">
    <div class="top-operate">
      <el-button type="text" class="back-button" @click="onGoBack">
        返回
      </el-button>
    </div>
    <div class="title default forget-title">忘记密码</div>
    <el-form
      ref="forgetForm"
      :rules="forgetFormRules"
      :model="forgetForm"
      class="form"
    >
      <!-- 电话号码 -->
      <el-form-item prop="mobile">
        <el-input
          v-model.trim="forgetForm.mobile"
          placeholder="请输入电话号码"
          size="medium"
          class="height-input"
        >
          <i slot="prefix" class="icon iconfont icon-zhanghao"></i>
        </el-input>
      </el-form-item>

      <!-- 短信验证码 -->
      <el-form-item prop="smsCode">
        <div class="flex">
          <el-input
            v-model.trim="forgetForm.smsCode"
            class="height-input flex-1"
            placeholder="请输入验证码"
            size="medium"
            @keyup.enter.native="onSubmit"
          >
            <i slot="prefix" class="icon iconfont icon-yanzhengma"></i>
          </el-input>
          <!-- 短信验证码按钮 -->
          <count-down-button
            ref="countDown"
            class="count-down-button"
            :max-count="60"
            :mobile="forgetForm.mobile"
            :template-code="templateCodeObj.forgetPwd"
            @click.native="handleCountDown"
            @getSmsToken="data => (forgetForm.smsToken = data.token)"
          />
        </div>
      </el-form-item>
    </el-form>

    <el-button
      class="one-line m-t-24"
      :loading="loading"
      type="primary"
      size="medium"
      @click="onSubmit"
    >
      下一步
    </el-button>
  </div>
</template>

<script>
import CountDownButton from '@/components/CountDownButton'
import {
  forgetPasswordVerifyMobileApi,
  searchIfMobileOccupiedApi
} from '@/api/user.js'

// 引入数据字典
import { templateCodeObj } from '@/dictionary'

export default {
  name: 'Forget',
  components: {
    CountDownButton
  },
  data() {
    // 手机号是否已注册校验
    const validateMobile = function(rule, value, callback) {
      if (!value) {
        return callback()
      }

      searchIfMobileOccupiedApi({ mobile: value })
        .then(res => {
          if (!res.data) {
            callback(new Error('当前手机号未注册'))
          } else {
            callback()
          }
        })
        .catch(err => {
          callback(new Error(err.data.message))
        })
    }
    return {
      templateCodeObj: templateCodeObj,
      // 登录表单数据
      forgetForm: {
        mobile: '', // 手机号
        smsCode: '', // 验证码
        smsToken: ''
      },
      // 登录表单校验
      forgetFormRules: {
        mobile: [
          {
            required: true,
            message: '请输入手机号码',
            trigger: ['blur', 'change']
          },
          {
            pattern: /^[0-9]{11}$/,
            message: '请输入正确的11位手机号码',
            trigger: ['blur']
          },
          {
            validator: validateMobile,
            trigger: ['blur']
          }
        ],
        smsCode: [
          {
            required: true,
            message: '短信验证码不能为空',
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false
    }
  },
  methods: {
    onGoBack() {
      this.$router.back()
    },
    // 点击验证码获取按钮
    handleCountDown() {
      this.$refs.forgetForm.validateField('mobile', fail => {
        if (!fail) {
          this.$refs.countDown.showDialog()
        }
      })
    },

    onSubmit() {
      this.$refs.forgetForm.validate(valid => {
        if (!valid) return

        this.loading = true
        forgetPasswordVerifyMobileApi(this.forgetForm)
          .then(res => {
            this.loading = false
            this.$router.replace({
              name: 'Reset',
              query: {
                sign: res.data.sign
              }
            })
          })
          .catch(err => {
            this.loading = false
            this.$message.error(err.data.message)
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.forget {
  padding: pixel-to-rem($n: 100) pixel-to-rem($n: 76) !important;

  .count-down-button {
    margin-left: pixel-to-rem($n: 20);
    height: 40px;
  }
}
</style>
